module.exports = __webpack_public_path__ + "static/media/rouletteStart_3.100cf08f.mp3";